import { defineComponent as _defineComponent } from 'vue'
import { NameType } from '@/views/Automation/CampaignCreatorV2/ab/core/helpers';
import CcAlert from '@/views/Automation/CampaignCreatorV2/components/CcAlert/CcAlert.ts.vue';
import CcCard from '@/views/Automation/CampaignCreatorV2/components/CcCard/CcCard.ts.vue';
import CcError from '@/views/Automation/CampaignCreatorV2/components/CcError/CcError.ts.vue';
import CcIcon from '@/views/Automation/CampaignCreatorV2/components/CcIcon/CcIcon.ts.vue';
import CcCreateTemplateModal from '@/views/Automation/CampaignCreatorV2/components/Modals/CcCreateTemplateModal.ts.vue';
import { useTour } from '@/views/Automation/CampaignCreatorV2/helpers/tourGuide';
import useAdSetStore from '@/views/Automation/CampaignCreatorV2/store/AdSet';
import { storeToRefs } from 'pinia';
import { computed, onMounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AdSetName.ts',
  setup(__props) {

onMounted(() => {
  useTour('AdSet');
});

const adSetStore = useAdSetStore();
const { getField, getMacroOptions } = storeToRefs(adSetStore);

const createTemplateModal = ref<NullableType<InstanceType<typeof CcCreateTemplateModal>>>(null);

const adSetName = computed(() => getField.value('name')?.value?.[0]);
const macros = computed(() => getMacroOptions.value);

function onNameChange(value: string, variableId = 'name') {
  const currentName = adSetName.value.value || {};
  adSetStore.addOrEditVariable('name', { field: 'name', value: { ...currentName, name: value }, variableId });
}

function openCreateTemplateModal() {
  createTemplateModal.value?.onModalOpen();
}

function onTemplateCreate(value: Omit<NameType, 'name'>, variableId = 'name') {
  const currentName = adSetName.value.value || {};
  adSetStore.addOrEditVariable('name', {
    field: 'name',
    value: { ...currentName, ...value },
    variableId,
  });
}

return { __sfc: true,adSetStore, getField, getMacroOptions, createTemplateModal, adSetName, macros, onNameChange, openCreateTemplateModal, onTemplateCreate, CcAlert, CcCard, CcError, CcIcon, CcCreateTemplateModal }
}

})